module.exports = __webpack_public_path__ + "img/unpublish-3.692c6fcb.svg";